<div class="p-6 sm:p-8 max-w-7xl w-full mx-auto space-y-6 animate-in fade-in duration-300">
  <!-- Section Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 class="text-2xl font-bold text-slate-800 flex items-center gap-2">
        <svg lucideTrendingUp class="h-7 w-7 text-sakoo-green"></svg>
        Tasas de Cambio
      </h1>
      <p class="text-sm text-slate-500 mt-1">
        Modifica la tasa de cambio activa y visualiza el historial de auditoría de los últimos 7 días.
      </p>
    </div>
    <button hlmBtn variant="outline" size="sm" (click)="loadRatesHistory()" [disabled]="isLoadingHistory()"
      class="gap-1.5 text-xs font-semibold border-slate-200 text-slate-600 hover:text-slate-900 bg-white">
      @if (isLoadingHistory()) {
      <hlm-spinner class="text-sm" />
      } @else {
      <svg lucideRefreshCw class="h-3.5 w-3.5"></svg>
      }
      Sincronizar Historial
    </button>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-12 gap-8">
    <!-- FORM CARD (LEFT) -->
    <div class="lg:col-span-4 bg-white border border-slate-200 rounded-2xl p-6 shadow-xs space-y-4 flex flex-col">
      <div class="border-b border-slate-100 pb-4">
        <h2 class="text-lg font-bold text-slate-800">
          {{ selectedRateId() ? 'Modificar Tasa de Cambio' : 'Selecciona una Tasa' }}
        </h2>
        <p class="text-xs text-slate-400 mt-0.5">
          {{ selectedRateId() ? 'Ingresa los nuevos valores para guardar y aprobar' :
          'Haz clic en una tasa del historial para comenzar' }}
        </p>
      </div>

      @if (selectedRateId()) {
      <form (submit)="$event.preventDefault()" class="space-y-4">
        <!-- Compra -->
        <div class="flex flex-col gap-1.5">
          <label hlmLabel for="rate_from" class="text-slate-700 font-semibold text-sm">
            Tasa Compra
          </label>
          <div class="relative flex items-center">
            <input id="rate_from" type="number" step="0.0001" [formField]="ratesForm.rate_from" hlmInput
              class="h-10 border-slate-200 focus-visible:border-sakoo-green focus-visible:ring-sakoo-green/20" />
          </div>
          @if (ratesForm.rate_from().touched() && ratesForm.rate_from().errors().length) {
          <div class="flex items-center gap-1 text-xs text-rose-500 mt-1">
            <svg lucideAlertCircle class="h-3.5 w-3.5"></svg>
            <span>{{ ratesForm.rate_from().errors()[0].message }}</span>
          </div>
          }
        </div>

        <!-- Venta -->
        <div class="flex flex-col gap-1.5">
          <label hlmLabel for="rate_to" class="text-slate-700 font-semibold text-sm">
            Tasa Venta
          </label>
          <div class="relative flex items-center">
            <input id="rate_to" type="number" step="0.0001" [formField]="ratesForm.rate_to" hlmInput
              class="h-10 border-slate-200 focus-visible:border-sakoo-green focus-visible:ring-sakoo-green/20" />
          </div>
          @if (ratesForm.rate_to().touched() && ratesForm.rate_to().errors().length) {
          <div class="flex items-center gap-1 text-xs text-rose-500 mt-1">
            <svg lucideAlertCircle class="h-3.5 w-3.5"></svg>
            <span>{{ ratesForm.rate_to().errors()[0].message }}</span>
          </div>
          }
        </div>

        <!-- Promedio -->
        <div class="flex flex-col gap-1.5">
          <label hlmLabel for="rate_average" class="text-slate-700 font-semibold text-sm">
            Tasa Promedio / Oficial
          </label>
          <div class="relative flex items-center">
            <input id="rate_average" type="number" step="0.0001" [formField]="ratesForm.rate_average" hlmInput
              class="h-10 border-slate-200 focus-visible:border-sakoo-green focus-visible:ring-sakoo-green/20" />
          </div>
          @if (ratesForm.rate_average().touched() && ratesForm.rate_average().errors().length) {
          <div class="flex items-center gap-1 text-xs text-rose-500 mt-1">
            <svg lucideAlertCircle class="h-3.5 w-3.5"></svg>
            <span>{{ ratesForm.rate_average().errors()[0].message }}</span>
          </div>
          }
        </div>

        <!-- Fuente -->
        <div class="flex flex-col gap-1.5">
          <label hlmLabel for="source" class="text-slate-700 font-semibold text-sm">
            Fuente de la Tasa
          </label>
          <hlm-combobox [formField]="ratesForm.source" [itemToString]="sourceLabel">
            <hlm-combobox-trigger buttonId="source" class="w-full justify-between font-normal">
              <hlm-combobox-placeholder>Selecciona la fuente</hlm-combobox-placeholder>
              <ng-template hlmComboboxValueTemplate let-value>
                <span>{{ value }}</span>
              </ng-template>
            </hlm-combobox-trigger>
            <hlm-combobox-content *hlmComboboxPortal>
              <hlm-combobox-input showTrigger="false" placeholder="Buscar..." />
              <hlm-combobox-empty>Sin resultados.</hlm-combobox-empty>
              <div hlmComboboxList>
                <hlm-combobox-item value="BACKOFFICE">BACKOFFICE</hlm-combobox-item>
              </div>
            </hlm-combobox-content>
          </hlm-combobox>
          @if (ratesForm.source().touched() && ratesForm.source().errors().length) {
          <div class="flex items-center gap-1 text-xs text-rose-500 mt-1">
            <svg lucideAlertCircle class="h-3.5 w-3.5"></svg>
            <span>{{ ratesForm.source().errors()[0].message }}</span>
          </div>
          }
        </div>

        <!-- Submit Button: abre el diálogo de confirmación antes de aprobar -->
        <button hlmBtn type="button" (click)="isApproveDialogOpen.set(true)"
          class="w-full h-10 text-sm font-bold bg-sakoo-green text-slate-800 hover:bg-sakoo-green/90 border-transparent transition-all shadow-md active:translate-y-px mt-2 gap-2"
          [disabled]="ratesForm().invalid() || ratesForm().pending() || isSubmitting()">
          @if (isSubmitting()) {
          <hlm-spinner class="text-base" />
          <span>Guardando...</span>
          } @else {
          <span>Aprobar y Guardar Tasa</span>
          }
        </button>
      </form>

      <!-- Diálogo de confirmación antes de aprobar y guardar la tasa -->
      <hlm-alert-dialog [state]="isApproveDialogOpen() ? 'open' : 'closed'">
        <hlm-alert-dialog-content *hlmAlertDialogPortal>
          <hlm-alert-dialog-header>
            <h2 hlmAlertDialogTitle>¿Aprobar esta tasa de cambio?</h2>
            <p hlmAlertDialogDescription>
              Esta acción guardará y aprobará la tasa de cambio seleccionada. Verifica los valores
              antes de continuar.
            </p>
          </hlm-alert-dialog-header>
          <hlm-alert-dialog-footer>
            <button hlmAlertDialogCancel (click)="isApproveDialogOpen.set(false)">
              Cancelar
            </button>
            <button hlmAlertDialogAction (click)="confirmApproval()"
              class="bg-sakoo-green text-slate-800 hover:bg-sakoo-green/90 border-transparent">
              Sí, aprobar
            </button>
          </hlm-alert-dialog-footer>
        </hlm-alert-dialog-content>
      </hlm-alert-dialog>
      } @else {
      <div
        class="flex flex-1 flex-col items-center justify-center p-8 text-center bg-slate-50 rounded-xl border border-dashed border-slate-200 min-h-64">
        <svg lucideCalendar class="h-12 w-12 text-slate-300 mb-2"></svg>
        <p class="text-sm text-slate-500 font-medium">Ninguna tasa seleccionada</p>
        <p class="text-xs text-slate-400 mt-1">
          Selecciona una fila del historial para modificar la tasa de cambio.
        </p>
      </div>
      }
    </div>

    <!-- HISTORY CARD (RIGHT) -->
    <div class="lg:col-span-8 bg-white border border-slate-200 rounded-2xl p-6 shadow-xs space-y-4">
      <div class="border-b border-slate-100 pb-4 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <h2 class="text-lg font-bold text-slate-800">Historial de los Últimos 7 Días</h2>
        <!-- Selector de Moneda -->
        <div class="flex flex-col gap-1.5 w-full sm:w-56">
          <label hlmLabel for="currency-filter" class="text-slate-700 font-semibold text-xs">
            Moneda
          </label>
          <hlm-combobox [value]="selectedCurrency()" (valueChange)="onCurrencyChange($any($event))"
            [itemToString]="currencyLabel">
            <hlm-combobox-trigger buttonId="currency-filter" class="w-full justify-between font-normal">
              <hlm-combobox-placeholder>Selecciona una moneda</hlm-combobox-placeholder>
              <ng-template hlmComboboxValueTemplate let-value>
                <span>{{ currencyLabel(value) }}</span>
              </ng-template>
            </hlm-combobox-trigger>
            <hlm-combobox-content *hlmComboboxPortal>
              <hlm-combobox-input showTrigger="false" placeholder="Buscar moneda..." />
              <hlm-combobox-empty>No se encontraron monedas.</hlm-combobox-empty>
              <div hlmComboboxList>
                @for (currency of currencies(); track currency.id) {
                <hlm-combobox-item [value]="currency.code">{{ currency.code }} - {{ currency.name }}</hlm-combobox-item>
                }
              </div>
            </hlm-combobox-content>
          </hlm-combobox>
        </div>
      </div>

      <app-data-table [data]="filteredRates()" [columns]="historyColumns()" [loading]="isLoadingHistory()"
        loadingMessage="Cargando historial..."
        [emptyMessage]="'No hay registros de tasas para ' + selectedCurrency() + '.'" [filterable]="true"
        filterPlaceholder="Filtrar por fecha, fuente, estado..." [pageSize]="10" minHeight="18rem" [rowClickable]="true"
        [trackBy]="rateRowId" [selectedId]="selectedRateId()" (rowClick)="selectRate($event)" />

      <!-- Plantilla de la celda "Estado" (badge) usada por el data-table -->
      <ng-template #statusCell let-rate>
        <span [class.bg-emerald-50]="rate.status === 'APPROVED'" [class.text-emerald-700]="rate.status === 'APPROVED'"
          [class.border-emerald-100]="rate.status === 'APPROVED'" [class.bg-amber-50]="rate.status !== 'APPROVED'"
          [class.text-amber-700]="rate.status !== 'APPROVED'" [class.border-amber-100]="rate.status !== 'APPROVED'"
          class="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border">
          {{ rate.status }}
        </span>
      </ng-template>
    </div>
  </div>
</div>